export const defaultData = {
  testerDetails: {
    companyName: '',
    engineerName: '',
    telephone: '',
    qualifications: ''
  },
  premisesDetails: {
    siteName: '',
    siteType: 'NHS / Healthcare Hospital (TMV3 / D08)',
    siteAddress: '',
    postCode: '',
    testDate: new Date().toISOString().split('T')[0]
  },
  valveSpecification: {
    valveTagNumber: 'TMV-01',
    valveLocation: 'Ensuite Bathroom / Ward 3 Washbasin',
    tmvScheme: 'TMV3 (Healthcare / High Risk)',
    applicationKey: 'tmv3_washbasin',
    valveMakeModel: 'Rada / Horne / Reliance 15mm TMV3',
    valveSizeMm: '15mm'
  },
  temperatureReadings: {
    hotSupplyTempC: 58.5,
    coldSupplyTempC: 14.2,
    hotSupplyDynamicPressureBar: 2.2,
    coldSupplyDynamicPressureBar: 2.1,
    setMixedOutletTempC: 39.5,
    maxAllowableTempC: 41.0
  },
  failSafeTesting: {
    failSafeResponseTimeSec: 0.8,
    residualSeepageMl: 15,
    failSafeResult: 'Pass (Immediate Shut-off <= 1.5s)',
    restoredMixedTempC: 39.7,
    tempStabilityWithin2C: 'Yes'
  },
  mechanicalServicing: {
    strainersCleaned: 'Yes',
    checkValvesTested: 'Pass - Sound',
    descalingRequired: 'No - Clean',
    isolationValvesOperating: 'Yes'
  },
  summaryAndDeclarations: {
    overallResult: 'SATISFACTORY / COMPLIANT',
    remedialActionNotes: 'Valve operational, fail-safe shut-off test confirmed within 0.8s, temperature stable at 39.5°C.',
    nextInspectionDue: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    engineerSignature: '',
    clientSignature: ''
  }
};

export default defaultData;
